module.exports = __webpack_public_path__ + "assets/tools-48a530610ec5787bb229f05c6a5db8b4.svg";